import styled from '@emotion/styled';

export const FeaturedWrapper = styled.div`
  height: 100%;
`;
